module.exports = __webpack_public_path__ + "static/media/graduation cap.b84eb9cb.png";